export default __webpack_public_path__ + "static/media/img-67.29d96dc8.jpg";